import { Link } from 'gatsby';
import React, { Component } from "react";

export class CookieBanner extends Component {
  constructor(props: any) {
    super(props);
    this.state = { cookieBannerDismissed: true };
    this.cookieDismissClicked = this.cookieDismissClicked.bind(this);
  }

  componentDidMount() {
    this.setState({ cookieBannerDismissed: localStorage.getItem('cookie-banner-dismissed') !== null });
  }

  cookieDismissClicked() {
    localStorage.setItem('cookie-banner-dismissed', 'true');
    this.setState({ cookieBannerDismissed: true });
  }

  render() {
    return (
      <div className={`${(this.state as any).cookieBannerDismissed ? 'hidden' : 'flex'} bottom-0 fixed h-16 text-center bg-yellow-300 bg-opacity-80 w-full items-center justify-center`}>
        <p className="m-0 p-0">markerjs.com uses cookies for basic site operations and to collect 
        anonymized statistics. <Link to="/privacy" className="text-pink-600">Privacy policy</Link>.</p>
        <button onClick={this.cookieDismissClicked}
          className="hover:bg-yellow-200 rounded-full py-1 px-8 border-2 border-pink-600 ml-5 text-sm">OK</button>
      </div>
    );
  }
}
